module.exports = __webpack_public_path__ + "06_face.84fed705.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer1/06_face.png
// module id = nUtc
// module chunks = 0